var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Android"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Android",
    clipPath: "url(#clip-Android)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "android-droid-material-svgrepo-com",
    transform: "translate(-13.886 2.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4560",
    "data-name": "Path 4560",
    d: "M112.916,2.472,114.164.566a.372.372,0,0,0-.095-.5.347.347,0,0,0-.489.1l-1.288,1.969a5.737,5.737,0,0,0-4.884,0L106.119.159a.347.347,0,0,0-.489-.1.372.372,0,0,0-.095.5l1.248,1.907a6.1,6.1,0,0,0-2.8,4.7H115.72A6.1,6.1,0,0,0,112.916,2.472Zm-5.463,2.865a.848.848,0,1,1,.822-.848A.835.835,0,0,1,107.453,5.338Zm4.792,0a.848.848,0,1,1,.822-.848A.835.835,0,0,1,112.246,5.338Z",
    transform: "translate(-83.623 0)",
    fill: "#2e78d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4561",
    "data-name": "Path 4561",
    d: "M101.653,208.445v7.005a.987.987,0,0,0,.969,1h1.6v1.635a1,1,0,1,0,2,0v-1.635h2.818v1.635a1,1,0,1,0,2,0v-1.635h1.392a.988.988,0,0,0,.969-1v-8.489H101.653Z",
    transform: "translate(-81.39 -199.115)",
    fill: "#2e78d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4562",
    "data-name": "Path 4562",
    d: "M18.076,206.961a1.193,1.193,0,0,0-1.19,1.19v3.919a1.19,1.19,0,1,0,2.38,0v-3.919A1.193,1.193,0,0,0,18.076,206.961Z",
    transform: "translate(0 -198.949)",
    fill: "#2e78d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4563",
    "data-name": "Path 4563",
    d: "M436.577,206.961a1.193,1.193,0,0,0-1.19,1.19v3.919a1.19,1.19,0,0,0,2.38,0v-3.919A1.193,1.193,0,0,0,436.577,206.961Z",
    transform: "translate(-402.2 -198.949)",
    fill: "#2e78d5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/Android.ac20ce37f593cf89c8b63fc4f77b8464.svg";
export { ForwardRef as ReactComponent };